import { useState } from "react";
import { ChevronDown } from "lucide-react";

export function FAQItem({ question, children, icon: Icon, defaultOpen = false }) {
    const [isOpen, setIsOpen] = useState(defaultOpen);

    return (
        <div
            className={`group rounded-2xl border transition-all duration-200 ease-out ${
                isOpen
                    ? "border-indigo-200 bg-indigo-50/30 shadow-sm"
                    : "border-slate-200 bg-white hover:border-slate-300 hover:shadow-sm"
            }`}
        >
            <button
                type="button"
                onClick={() => setIsOpen(!isOpen)}
                className="w-full flex items-center gap-4 p-5 text-left"
            >
                {Icon && (
                    <div className={`flex-shrink-0 w-9 h-9 rounded-xl flex items-center justify-center transition-colors duration-200 ${
                        isOpen ? "bg-indigo-100 text-indigo-600" : "bg-slate-100 text-slate-500"
                    }`}>
                        <Icon className="w-4.5 h-4.5" />
                    </div>
                )}
                <span className="flex-1 text-base font-semibold text-slate-800">
                    {question}
                </span>
                <ChevronDown
                    className={`w-5 h-5 text-slate-400 flex-shrink-0 transition-transform duration-200 ease-out ${
                        isOpen ? "rotate-180" : ""
                    }`}
                />
            </button>
            <div
                className={`overflow-hidden transition-all duration-200 ease-out ${
                    isOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
                }`}
            >
                <div className="px-5 pb-5 pt-0 text-slate-600 leading-relaxed text-sm space-y-2">
                    {children}
                </div>
            </div>
        </div>
    );
}
